.card {
  border-radius: 0.3rem;
  box-shadow:
    rgba(22, 31, 39, 0.42) 0 20px 40px -10px,
    rgba(19, 26, 32, 0.08) 0 10px 20px -15px;
  transform: perspective(20em) rotateX(0deg);
}

.fixed {
  background-color: white;
}

.floating {
  background-color: white;
  box-shadow: var(--shadow-primary);
  transform: perspective(20em) rotateX(1deg);
  transition:
    transform 0.4s,
    box-shadow 0.4s ease-out;
}

.floating:hover {
  box-shadow: var(--shadow-close);
  transform: rotateX(4deg);
}

.collapsable {
  background-color: transparent;
}

.padding_none {
  padding: 0;
}

.padding_medium {
  padding: 1rem;
}

.padding_large {
  padding: 2rem;
}
